import { c as _c } from "react/compiler-runtime";
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { SectionTitle } from '@cc-shopping/ui/composites/SectionTitle';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { tableOfContentsMap } from 'src/app/credit-cards/reviews/components/Body/TableOfContents/constants';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
export default function DrawbacksAndConsiderations() {
  const $ = _c(4);
  const {
    drawbacksAndConsiderations
  } = useReviewContext();
  if (!drawbacksAndConsiderations) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SectionTitle icon={{
      iconNode: <span aria-hidden="true" data-testid="section-title-icon" className="mask-icon mask-icon-psychology" style={{
        width: "2rem",
        height: "2rem",
        backgroundColor: "#008254"
      }} />
    }} heading={{
      text: "Drawbacks and Considerations"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      md: 5
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drawbacksAndConsiderations) {
    t2 = <Grid id={tableOfContentsMap.DRAWBACKS_AND_CONSIDERATIONS.id} size={12}><FeatureViewed entityName="accordion" entitySection="Drawbacks and considerations" impressionPosition={5}><div>{t0}<Box ml={t1}><StructuredContentRenderer doc={drawbacksAndConsiderations} /></Box></div></FeatureViewed></Grid>;
    $[2] = drawbacksAndConsiderations;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}